import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { writerOrderListSelector } from 'store/Writer/OrderList';
import OrdersStatusTable from 'components/shared/Table/OrdersStatusTable';
import { WRITER_VALIDATED_ORDERS_COLUMN } from 'utils/Constants';
import { ORDERSTATUS } from 'utils/Constants';

function WriterDelayedOrders() {
  const columns = WRITER_VALIDATED_ORDERS_COLUMN;

  const { t } = useTranslation();

  //selected the validated orders from the orderlist store
  const { delayedOrders, isLoading } = useSelector(writerOrderListSelector);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  return (
    <>
      <OrdersStatusTable
        title={t('Commandes en retard')}
        columns={columns}
        orders={delayedOrders}
        isLoading={isLoading}
        orderStatus={ORDERSTATUS.DELAYED}
      />
    </>
  );
}

export default WriterDelayedOrders;
